/**
 * Default text for the new editor (test variant)
 * Features emotion brackets that get highlighted in the editor
 */
export const NEW_EDITOR_DEFAULT_TEXT =
  'In the mist-shrouded land of Vyrneth, where mountains hummed with ancient magic and the seas glowed beneath a twilight sky, there roamed a fox named Sylvara. Not your "sneaky trickster" type… [chuckles] but a clever spirit, her fur sparkling like woven moonlight. [whispers] When she tread softly through the glades, even the shadows held their breath.';

/**
 * Default voice for the new editor (test variant)
 */
export const NEW_EDITOR_DEFAULT_VOICE = 'Maggie';


/**
 * Language-specific default texts for the new editor
 * Translated versions of the Vyrneth fox story with emotion brackets
 */
export const LANGUAGE_DEFAULT_TEXTS: Record<string, string> = {
  // English
  'en-US': NEW_EDITOR_DEFAULT_TEXT,
  'en-GB': NEW_EDITOR_DEFAULT_TEXT,

  // Hindi (hi)
  'hi-IN':
    'धुंध और रहस्यों से ढकी भूमि वायर्नेथ में, जहाँ पहाड़ प्राचीन मंत्रों की गूँज से कांपते थे और सागर सांझ की लहरों पर चाँदनी बिखेरते थे — वहाँ एक लोमड़ी भटकती थी, जिसका नाम था सिल्वारा। वह कोई साधारण “चालाक धोखेबाज़” नहीं थी… [laughs softly] बल्कि एक ज्ञानी आत्मा, जिसके फर में जैसे रेशमी चाँदनी उतर आई हो। [whispers softly] जब वह धीमे कदमों से जंगल की ओस भरी पगडंडियों पर चलती, तो हवा ठहर जाती, और परछाइयाँ उसकी मौन कथा सुनने लगतीं.',

  // German (de)
  'de-DE':
    'Im Nebelreich Vyrneth, wo Berge uralte Lieder flüsterten und das Meer in sanftem Zwielicht glühte, wanderte eine Füchsin namens Sylvara. Sie war keine gewöhnliche „listige Täuscherin“… [laughs softly] sondern ein weiser Geist, ihr Fell schimmernd wie feines Mondlicht, das in Silberfäden gewebt war. [whispers softly] Wenn sie lautlos durch das feuchte Moos schritt, hielten selbst die Schatten inne – als lauschten sie ihrem Herzschlag.',

  // French (fr)
  'fr-FR':
    'Dans le royaume brumeux de Vyrneth, les montagnes murmuraient d’antiques secrets et la mer scintillait d’une lumière d’argent au crépuscule. Là errait une renarde nommée Sylvara — pas une simple « rusée trompeuse »… [laughs softly] mais une âme ancienne, dont la fourrure semblait tissée de clair de lune. [whispers softly] Quand elle glissait entre les fougères endormies, même le vent retenait son souffle pour ne pas troubler sa grâce.',

  // Spanish (es)
  'es-ES':
    'En las tierras envueltas por la niebla de Vyrneth, las montañas susurraban viejos conjuros y el mar reflejaba el fuego del atardecer. Vagaba allí una zorra llamada Sylvara — no una simple « astuta embustera »… [laughs softly] sino un espíritu antiguo, con un pelaje que brillaba como la seda bajo la luna. [whispers softly] Cuando cruzaba despacio los claros del bosque, hasta las sombras detenían su aliento, temiendo romper la magia de su paso.',
  'es-MX':
    'En las tierras envueltas por la niebla de Vyrneth, las montañas susurraban viejos conjuros y el mar reflejaba el fuego del atardecer. Vagaba allí una zorra llamada Sylvara — no una simple « astuta embustera »… [laughs softly] sino un espíritu antiguo, con un pelaje que brillaba como la seda bajo la luna. [whispers softly] Cuando cruzaba despacio los claros del bosque, hasta las sombras detenían su aliento, temiendo romper la magia de su paso.',

  // Italian (it)
  'it-IT':
    'Nella terra velata di nebbia di Vyrneth, dove le montagne sussurravano antichi incantesimi e il mare brillava sotto la luce del crepuscolo, camminava una volpe di nome Sylvara. Non era una semplice “furba ingannatrice”… [laughs softly] ma uno spirito saggio, il suo manto lucente come la seta bagnata di luna. [whispers softly] Quando attraversava i sentieri del bosco, persino il vento taceva, rapito dalla grazia del suo passo.',

  // Portuguese (pt)
  'pt-BR':
    'Nas terras cobertas de névoa de Vyrneth, onde as montanhas murmuravam feitiços antigos e o mar brilhava sob a luz suave do entardecer, caminhava uma raposa chamada Sylvara. Ela não era uma “astuta enganadora”… [laughs softly] mas um espírito sereno, com a pelagem reluzente como fios de luar trançados. [whispers softly] Quando andava pela floresta adormecida, até as sombras paravam, ouvindo o silêncio de sua alma.',

  // Dutch (nl)
  'nl-NL':
    'In het met mist omhulde rijk Vyrneth, waar bergen oude spreuken fluisterden en de zee gloeide in het schemerlicht, zwierf een vos genaamd Sylvara. Ze was geen gewone “sluwe bedriegeres”… [laughs softly] maar een wijze geest, haar vacht glanzend als geweven maanlicht. [whispers softly] Wanneer ze zacht door het mos stapte, hield zelfs de nacht zijn adem in — bang de stilte te breken.',

  // Polish (pl)
  'pl-PL':
    'W spowitym mgłą królestwie Vyrneth, gdzie góry szeptały dawne zaklęcia, a morze płonęło blaskiem zmierzchu, wędrowała lisica imieniem Sylvara. Nie była zwykłą „chytrą oszustką”… [laughs softly] lecz mądrą duszą, której futro lśniło niczym jedwabny księżycowy promień. [whispers softly] Gdy stąpała lekko po leśnych ścieżkach, nawet cienie milkły, zasłuchane w ciszę jej kroków.',

  // Turkish (tr)
  'tr-TR':
    'Sislerle örtülü Vyrneth diyarında, dağlar kadim dualar fısıldar, deniz alacakaranlığın ışığında parlar, bir tilki dolaşırdı — adı Sylvara. O, sıradan bir “kurnaz aldatıcı” değildi… [laughs softly] bilge bir ruhtu, tüyleri ay ışığının ince dokusuyla parıldardı. [whispers softly] Ormanda sessizce yürüdüğünde, rüzgar bile durur, gölgeler nefesini tutardı.',

  // Arabic (ar)
  'ar-SA':
    'في مملكة فيرنيث المغمورة بالضباب، كانت الجبال تهمس بتعاويذ قديمة، والبحر يتلألأ بضوء الشفق. هناك كانت تسير ثعلبة تُدعى سيلفارا. لم تكن “خدّاعة ماكرة”... [laughs softly] بل روحًا حكيمة، يلمع فراؤها كخيوط ضوء القمر المنسوجة. [whispers softly] حين تمشي بخفة بين الأشجار، يسكن النسيم، وتصغي الظلال لأنفاسها الهادئة.',

  // Japanese (ja)
  'ja-JP':
    '霧に包まれた王国ヴィルネス。山々は古の呪文をささやき、海は夕暮れの光にきらめいていた。その森を、一匹の狐シルヴァラが歩いていた。彼女はただの「ずる賢い妖狐」ではなかった… [laughs softly] 静かな知恵を宿す魂、毛並みは月光の糸のように輝いていた。 [whispers softly] 足音が苔を撫でるたび、風も影も息をひそめた。',

  // Korean (ko)
  'ko-KR':
    '안개가 뒤덮인 비르네스의 땅, 산들은 오래된 주문을 속삭이고 바다는 황혼빛으로 물들었다. 그곳을 한 마리 여우, 실바라가 거닐고 있었다. 그녀는 단순한 “교활한 속임꾼”이 아니었다… [laughs softly] 달빛이 실처럼 얽힌 듯한 지혜로운 영혼이었다. [whispers softly] 그녀가 숲길을 조용히 걸을 때면, 바람도 멈추고 그림자도 숨을 죽였다.',

  // Chinese Simplified (zh-CN)
  'zh-CN':
    '在被薄雾笼罩的维尔内斯王国，群山低语着古老的咒语，大海在暮光中闪烁。一只名叫西尔瓦拉的狐狸漫步于林间。她并非寻常的“狡猾骗子”… [laughs softly] 而是一位智慧的灵魂，毛色如编织的月光般柔和。 [whispers softly] 当她轻轻走过森林的小径，连风都停下，影子也屏住呼吸。',

  // Chinese Traditional (zh-TW)
  'zh-TW':
    '在被薄霧籠罩的維爾奈斯王國裡，群山低語著古老的咒文，大海在暮光中閃耀。有一隻名叫席爾瓦拉的狐狸獨自行走於林間。她並非普通的「狡詐欺者」… [laughs softly] 而是一個睿智的靈魂，毛色柔亮如月光編織。 [whispers softly] 當她輕踏樹林小徑時，連風也靜止，影子亦屏息聆聽。',
};

/**
 * New editor style texts (localized)
 * Currently includes localized copy for the "Training" style
 */
export const NEW_EDITOR_STYLE_TEXTS: Record<string, Record<string, string>> = {
  'en-US': {
    'Training':
      "Welcome to our training module! [enthusiastic] In this session, you\'ll learn how to create professional voiceover in minutes. With Speechify Studio, you can simply type your script, choose from dozens of natural, expressive voices, and generate studio-quality audio instantly. No microphones, no editing — just polished narration ready to use. [excited] Try it today and sound like a pro!",
    'Sports Commentator':
      '[very quickly] And we’re off here at the Chase Center — the energy is electric for this Western Conference clash! The Warriors waste no time — [excited] Curry with the handle, crosses midcourt, a quick screen—pulls up from deep! [shouting] OH, HE GOT IT! From way downtown! The crowd’s on its feet, and Golden State are heating up early! This is vintage Warriors basketball!',
    'Professional Intro':
      'Welcome to Aether Innovations! [enthusiastic] We’re a passionate team creating cutting-edge software solutions. [energetic] From mobile apps to AI analytics, we turn your ideas into reality. [confident] Need a tech partner? [friendly] Reach out and let’s build something amazing together!',
  },
  'en-GB': {
    'Training':
      "Welcome to our training module! [enthusiastic] In this session, you\'ll learn how to create professional voiceover in minutes. With Speechify Studio, you can simply type your script, choose from dozens of natural, expressive voices, and generate studio-quality audio instantly. No microphones, no editing — just polished narration ready to use. [excited] Try it today and sound like a pro!",
    'Sports Commentator':
      '[very quickly] And we’re off here at the Chase Center — the energy is electric for this Western Conference clash! The Warriors waste no time — [excited] Curry with the handle, crosses midcourt, a quick screen—pulls up from deep! [shouting] OH, HE GOT IT! From way downtown! The crowd’s on its feet, and Golden State are heating up early! This is vintage Warriors basketball!',
    'Professional Intro':
      'Welcome to Aether Innovations! [enthusiastic] We’re a passionate team creating cutting-edge software solutions. [energetic] From mobile apps to AI analytics, we turn your ideas into reality. [confident] Need a tech partner? [friendly] Reach out and let’s build something amazing together!',
  },
  'de-DE': {
    'Training':
      'Willkommen zu unserem Podcast. Heute sprechen wir über Ideen, die inspirieren, und Geschichten, die zählen. Bleiben Sie dran.',
    'Sports Commentator':
      '[very quickly] Das Publikum tobt — was für ein Spielzug! [excited] Schneller Pass, Schuss aus der Distanz... [shouting] und er ist drin! [bursting with energy] Unglaublich!',
    'Professional Intro':
      '[warm] Erfrischen Sie Ihren Tag mit einem spritzigen, kräftigen Geschmack. [friendly] Dose öffnen, einen Schluck nehmen — [confident] die Frische spüren.',
  },
  'fr-FR': {
    'Training':
      "Bienvenue dans notre podcast. Aujourd'hui, nous explorons des idées inspirantes et des histoires qui comptent. Restez avec nous.",
    'Sports Commentator':
      "[very quickly] Le public est en délire — quelle action ! [excited] Passe rapide, tir lointain... [shouting] et c'est au fond ! [bursting with energy] Incroyable !",
    'Professional Intro':
      "[warm] Rafraîchissez votre journée avec un goût vif et pétillant. [friendly] Ouvrez une canette, prenez une gorgée — [confident] sentez l'étincelle.",
  },
  'es-ES': {
    'Training':
      'Bienvenido a nuestro podcast. Hoy exploramos ideas que inspiran e historias que importan. Quédate con nosotros.',
    'Sports Commentator':
      '[very quickly] ¡La afición ruge — qué jugada! [excited] Pase rápido, tiro desde lejos... [shouting] ¡y adentro! [bursting with energy] ¡Increíble!',
    'Professional Intro':
      '[warm] Refresca tu día con un sabor crujiente y lleno de vida. [friendly] Abre una lata, da un sorbo — [confident] y siente la chispa.',
  },
  'es-MX': {
    'Training':
      'Bienvenidos a nuestro podcast. Hoy exploramos ideas que inspiran e historias que importan. Quédense con nosotros.',
    'Sports Commentator':
      '[very quickly] ¡La afición ruge — qué jugada! [excited] Pase rápido, disparo de larga distancia... [shouting] ¡y adentro! [bursting with energy] ¡Impresionante!',
    'Professional Intro':
      '[warm] Refresca tu día con un sabor crujiente y lleno de vida. [friendly] Abre una lata, da un sorbo — [confident] siente la chispa.',
  },
  'it-IT': {
    'Training':
      'Benvenuti nel nostro podcast. Oggi esploriamo idee che ispirano e storie che contano. Restate con noi.',
    'Sports Commentator':
      '[very quickly] Il pubblico esplode — che giocata! [excited] Passaggio rapido, tiro da lontano... [shouting] ed è gol! [bursting with energy] Incredibile!',
    'Professional Intro':
      '[warm] Rinfresca la tua giornata con un gusto deciso e frizzante. [friendly] Apri una lattina, fai un sorso — [confident] senti la scintilla.',
  },
  'pt-BR': {
    'Training':
      'Bem-vindo ao nosso podcast. Hoje exploramos ideias que inspiram e histórias que importam. Fique com a gente.',
    'Sports Commentator':
      '[very quickly] A torcida vai à loucura — que jogada! [excited] Passe rápido, chute de longe... [shouting] e é gol! [bursting with energy] Incrível!',
    'Professional Intro':
      '[warm] Refresque o seu dia com um sabor marcante e crocante. [friendly] Abra a lata, dê um gole — [confident] sinta o brilho.',
  },
  'pt-PT': {
    'Training':
      'Bem-vindo ao nosso podcast. Hoje exploramos ideias inspiradoras e histórias que importam. Fica connosco.',
    'Sports Commentator':
      '[very quickly] A bancada vibra — que jogada! [excited] Passe rápido, remate de longe... [shouting] e é golo! [bursting with energy] Incrível!',
    'Professional Intro':
      '[warm] Refresca o teu dia com um sabor crocante e marcante. [friendly] Abre uma lata, dá um gole — [confident] sente o brilho.',
  },
  'nl-NL': {
    'Training':
      'Welkom bij onze podcast. Vandaag verkennen we ideeën die inspireren en verhalen die ertoe doen. Blijf luisteren.',
    'Sports Commentator':
      '[very quickly] Het publiek gaat uit z’n dak — wat een actie! [excited] Snel steekpassje, schot van afstand... [shouting] en hij zit! [bursting with energy] Ongelofelijk!',
    'Professional Intro':
      '[warm] Verfris je dag met een knapperige, krachtige smaak. [friendly] Open een blikje, neem een slok — [confident] en voel de sprankel.',
  },
  'pl-PL': {
    'Training':
      'Witamy w naszym podcaście. Dziś odkrywamy inspirujące pomysły i ważne historie. Zostań z nami.',
    'Sports Commentator':
      '[very quickly] Publiczność szaleje — co za zagranie! [excited] Szybkie podanie, strzał z dystansu... [shouting] i gol! [bursting with energy] Niesamowite!',
    'Professional Intro':
      '[warm] Odśwież swój dzień chrupkim, wyrazistym smakiem. [friendly] Otwórz puszkę, weź łyk — [confident] i poczuj iskrę.',
  },
  'vi-VN': {
    'Training':
      'Chào mừng đến với podcast của chúng tôi. Hôm nay chúng ta khám phá những ý tưởng truyền cảm hứng và những câu chuyện ý nghĩa. Hãy đồng hành cùng chúng tôi.',
    'Sports Commentator':
      '[very quickly] Khán đài nổ tung — một pha xử lý tuyệt vời! [excited] Chuyền nhanh, sút xa... [shouting] vào rồi! [bursting with energy] Không thể tin nổi!',
    'Professional Intro':
      '[warm] Làm mới ngày của bạn với hương vị đậm đà, sảng khoái. [friendly] Mở lon, nhấp một ngụm — [confident] và cảm nhận sự lấp lánh.',
  },
  'uk-UA': {
    'Training':
      'Вітаємо у нашому подкасті. Сьогодні ми досліджуємо ідеї, що надихають, та важливі історії. Залишайтеся з нами.',
    'Sports Commentator':
      '[very quickly] Трибуни шаленіють — яка комбінація! [excited] Швидка передача, удар здалеку... [shouting] і ГО-ОЛ! [bursting with energy] Неймовірно!',
    'Professional Intro':
      '[warm] Оновіть свій день яскравим, освіжаючим смаком. [friendly] Відкрийте банку, зробіть ковток — [confident] і відчуйте іскру.',
  },
  'ru-RU': {
    'Training':
      'Добро пожаловать в наш подкаст. Сегодня мы обсуждаем идеи, которые вдохновляют, и истории, которые важны. Оставайтесь с нами.',
    'Sports Commentator':
      '[very quickly] Трибуны ревут — вот это момент! [excited] Быстрый пас, удар издалека... [shouting] и ГОЛ! [bursting with energy] Невероятно!',
    'Professional Intro':
      '[warm] Освежите свой день ярким, насыщенным вкусом. [friendly] Откройте банку, сделайте глоток — [confident] и почувствуйте искру.',
  },
  'sv-SE': {
    'Training':
      'Välkommen till vår podcast. Idag utforskar vi idéer som inspirerar och berättelser som spelar roll. Häng med oss.',
    'Sports Commentator':
      '[very quickly] Publiken jublar — vilken aktion! [excited] Snabb passning, skott från distans... [shouting] och den sitter! [bursting with energy] Otroligt!',
    'Professional Intro':
      '[warm] Friska upp dagen med en krispig, tydlig smak. [friendly] Öppna en burk, ta en klunk — [confident] känn gnistan.',
  },
  'hi-IN': {
    'Training':
      'हमारे पॉडकास्ट में आपका स्वागत है। आज हम प्रेरणादायक विचारों और महत्वपूर्ण कहानियों पर बात करेंगे। जुड़े रहिए।',
    'Sports Commentator':
      '[very quickly] स्टेडियम गूंज उठा — क्या कमाल की चाल! [excited] तेज़ पास, लंबी दूरी से शॉट... [shouting] और गोल! [bursting with energy] अविश्वसनीय!',
    'Professional Intro':
      '[warm] अपने दिन को ताज़गी दें — बोल्ड और कुरकुरा स्वाद के साथ। [friendly] कैन खोलिए, एक सिप लीजिए — [confident] और चमक महसूस कीजिए।',
  },
  'ar-SA': {
    'Training':
      'مرحباً بكم في بودكاستنا. اليوم نستكشف أفكاراً ملهمة وقصصاً مؤثرة. ابقوا معنا.',
    'Sports Commentator':
      '[very quickly] الجمهور يشتعل حماساً — يا لها من لقطة! [excited] تمريرة سريعة، تسديدة من بُعد... [shouting] هدف! [bursting with energy] مذهل!',
    'Professional Intro':
      '[warm] أنعش يومك بمذاق منعش وقوي. [friendly] افتح العبوة، خذ رشفة — [confident] واشعر بالبريق.',
  },
  'he-IL': {
    'Training':
      'ברוכים הבאים לפודקאסט שלנו. היום נחקור רעיונות מעוררי השראה וסיפורים חשובים. הישארו איתנו.',
    'Sports Commentator':
      '[very quickly] הקהל משתולל — איזו פעולה! [excited] מסירה מהירה, בעיטה מרחוק... [shouting] וזה בפנים! [bursting with energy] לא ייאמן!',
    'Professional Intro':
      '[warm] רעננו את היום שלכם עם טעם חד ומרענן. [friendly] פתחו פחית, לגמו — [confident] והרגישו את הניצוץ.',
  },
  'tr-TR': {
    'Training':
      'Podcast’imize hoş geldiniz. Bugün ilham veren fikirleri ve önemli hikâyeleri konuşuyoruz. Bizimle kalın.',
    'Sports Commentator':
      '[very quickly] Tribünler ayağa kalktı — müthiş bir hareket! [excited] Hızlı pas, uzaklardan şut... [shouting] ve gol! [bursting with energy] İnanılmaz!',
    'Professional Intro':
      '[warm] Gününüzü keskin ve ferah bir tatla tazeleyin. [friendly] Kutu açın, bir yudum alın — [confident] ve ışıltıyı hissedin.',
  },
  'ja-JP': {
    'Training':
      'ポッドキャストへようこそ。本日は、心を動かすアイデアと大切な物語をお届けします。どうぞお楽しみに。',
    'Sports Commentator':
      '[very quickly] 観客が沸く——なんというプレー！ [excited] 素早いパス、ロングシュート… [shouting] 入った！ [bursting with energy] 信じられない！',
    'Professional Intro':
      '[warm] 一日の気分をリフレッシュ。キリッとした爽やかな味わい。 [friendly] 缶を開けて一口 — [confident] きらめきを感じて。',
  },
  'ko-KR': {
    'Training':
      '팟캐스트에 오신 것을 환영합니다. 오늘은 영감을 주는 아이디어와 의미 있는 이야기를 전해드립니다. 함께해 주세요.',
    'Sports Commentator':
      '[very quickly] 관중이 열광합니다 — 놀라운 장면! [excited] 빠른 패스, 장거리 슛... [shouting] 들어갔습니다! [bursting with energy] 대단해요!',
    'Professional Intro':
      '[warm] 하루를 상쾌하게 — 선명하고 시원한 맛. [friendly] 캔을 열고 한 모금 — [confident] 반짝임을 느껴보세요.',
  },
  'zh-CN': {
    'Training':
      '欢迎来到我们的播客。今天我们将探讨启发人心的想法和重要的故事，请继续收听。',
    'Sports Commentator':
      '[very quickly] 全场沸腾——多么精彩的配合！ [excited] 快速传球，远射…… [shouting] 进了！ [bursting with energy] 不可思议！',
    'Professional Intro':
      '[warm] 用清爽而有劲的口味点亮你的一天。 [friendly] 打开易拉罐，抿一口 — [confident] 感受那一丝火花。',
  },
  'zh-TW': {
    'Training':
      '歡迎收聽本節目。今天我們要分享啟發人心的想法與重要的故事，敬請期待。',
    'Sports Commentator':
      '[very quickly] 全場沸騰——多麼精彩的進攻！ [excited] 快速傳球，遠距離射門…… [shouting] 進了！ [bursting with energy] 不可思議！',
    'Professional Intro':
      '[warm] 用清爽、帶勁的口味喚醒你的一天。 [friendly] 打開易開罐，啜一口 — [confident] 感受那道火花。',
  },
};
